import React from 'react';
import UnifiedDateRangePicker from '../../common/UnifiedDateRangePicker';

// A plain labelled control (no card chrome) so it sits as a peer of the Type
// selector inside the single controls card — no nested card, matching labels.
const DateSelector = ({ startDate, setStartDate, endDate, setEndDate }) => {
  const toApi = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-3">Analysis Period</label>
      <UnifiedDateRangePicker
        startDate={startDate}
        onStartDateChange={(date) => setStartDate(toApi(date))}
        endDate={endDate}
        onEndDateChange={(date) => setEndDate(toApi(date))}
      />
    </div>
  );
};

export default DateSelector;
